import { SlideType } from "@/types/blocks.types";
import txnPool from "@public/carousel/txn-pool.png";
import modular from "@public/carousel/modular-permissions.png";
import selfBridge from "@public/carousel/self-bridging.png";
import { LINKS } from "@/constants/links.constant";

export const CAROUSEL_SLIDES: SlideType[] = [
  {
    image: txnPool,
    desc: "Transaction Pool Process",
    link: LINKS.KEY_APP.TRANSACTION_POOL,
  },
  {
    image: modular,
    desc: "Modular Permissions",
    link: LINKS.KEY_APP.MODULAR_PERMISSIONS,
  },
  {
    image: selfBridge,
    desc: "Self-bridging",
    link: LINKS.KEY_APP.MODULAR_PERMISSIONS,
  },
];
